<template>
  <div>
    <LastTerms />
  </div>
</template>

<script>
export default {
  name: 'Terms',
  components: {
    async LastTerms() {
      return import(`@/components/Terms/Terms-V1.0.0`);
    },
  },
  data() {
    return {
      termsVersion: null,
    };
  },
};
</script>
